;
export const Bio = {
  name: "Shatakshi rastogi",
  roles: [
    "Full Stack Developer",
    "Android Developer",
    "UI/UX Designer",
    "Programmer",
  ],
  description:
    "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
  github: "https://github.com/Shatakshi91",
  resume:
    "",
  linkedin: "",
  twitter: "",
  insta: "",
  facebook: "",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
  
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
    
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTz_tjesIG1hnmqUkkIpgPwFzq53l9o10tkIA&s",
      },
  
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Flask",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
      },
      
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "Postgresql",
        image: "https://www.postgresql.org/media/img/about/press/elephant.png",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "AWS",
        image:
          "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
      },
      {
        name: "Google Cloud",
        image:
          "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
      },
      
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Java",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
      },
      {
        name: "Kotlin",
        image:
          "https://www.vectorlogo.zone/logos/kotlinlang/kotlinlang-icon.svg",
      },
      
      
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "Tenserflow",
        image:
          "https://static-00.iconduck.com/assets.00/tensorflow-icon-1911x2048-1m2s54vn.png",
      },
      
      {
        name: "Jupyter",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
      },
      {
        name: "Google Colab",
        image:
          "https://educationecosystem.com/blog/wp-content/uploads/2021/01/1_Lad06lrjlU9UZgSTHUoyfA.png",
      },
      
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "GitHub",
        image:
          "https://foundations.projectpythia.org/_images/GitHub-logo.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
      },
      {
        name: "Adobe XD",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSOm89fAKxF6keXhN57da2auU240hHaJ8ABbA&s",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
    ],
  },
];

export const experiences = [
  
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSwkoyuLUQEWgxCxLDdOkpC6Uv4kQm6DHkQe0fjO2bMzYf-M5j2rkP6eK8m0ZBQEzf6b6E&usqp=CAU",
    role: "DevOps & Fullstack Engineering ",
    company: "",
    date: "Aug 2024 - Oct 2025",
    desc: "Built Flipr Connect Platforms using React Js integrated GraphQL with AXIOS, created High level Design and Figma design. Built Backend with GraphQL and Node JS and connected with MongoDb - Reducing API calls by 20%. Dockerized and automated with Kubernetes & Jenkins CI/CD deployed in AWS-EC2 added Prometheus & Grafana for monitoring.",
    skills: [
      "AWS",
      "Nginx",
      "JavaScript",
      "TypeScript",
      "Node Js",
      " Next Js",
    ],
    doc: "",
  },
  
   
  {
    id: 3,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQaaBRVPMQIb7DWwAiT_AA9hpbzqn7qOCriGQ&s",
    role: "Fullstack Externship",
    company: "",
    date: "June 2024 - July 2025",
    desc: "Built an employee management full stack web app used Docker and deployed on AWS ec2. I was the top performer in the program.",
    skills: [
      "ReactJS",
      "Redux",
      "NodeJs",
      "Material UI",
      "HTML",
      "CSS",
      "JavaScript",
      "Docker",
      "AWS",
      "MongoDB",
    ],
    doc: "",
  },
  
  {
    id: 5,
    img: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/girlScript.jpeg?alt=media&token=e656a621-cf3c-4230-bf0f-e74b4cec6035",
    role: "Open Source Contributor ",
    company: "GirlScript Summer of Code",
    date: "May 2024 - Present",
    desc: "Contributed to different open-source projects and learn from industry experts",
  },
  {
    id:6,
    img:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTr5OzNJPX4D-IiN_2SVkoN2JDyxnTEv22tVw&s",
    role:"participated in many hackthons",
    company:"",
    date:"2023 - 2025",
    desc:"participated in many hackthons and build many projects",
    
  }
];

export const education = [
  {
    id: 0,
    img: "https://i.pinimg.com/474x/f5/98/ee/f598ee10179fe7a47ffea40ce625b21d.jpg",
    school: "Chandigarh university, punjab mohali",
    date: "aug 2022 - Sep 2026",
    grade: "8 CGPA",
    desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at chandigarh university,punjab. I have completed 4 semesters and have a CGPA of 8 I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others. I am also a member of the Google Developers Student Club (GDSC) at cu , where I am learning and working on exciting projects with a team of talented developers.",
    degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
  },
  {
    id: 1,
    img: "https://www.smccjkanpur.org/images/school_emblem_Logo1.png",
    school: "St.mary convent high school",
    date: "Apr 2020 - Apr 2022",
    desc: "I completed my class 12 high school education at St.mary convent high school, kanpur, where I studied Science with Computer Science.",
    degree: "ISC(XII), Science with Computer",
    grade:"93"
  },
  {
    id: 2,
    img: "https://www.smccjkanpur.org/images/school_emblem_Logo1.png",
    school: "St.mary convent high school",
    date: "Apr 2019 - Apr 2020",
    desc: "I completed my class 10 education at St.mary convent high school, kanpur, where I studied Science with Computer Application.",
    degree: "ICSC(X), Science with Computer",
    grade:"90"
  },
];

export const projects = [
  {
    id: 11,
    title: "created a portfolio for others as freelancer",
    date: "Jan 2024 - Dec 2023",
    description:
      "as freelancer i made many projects for others and also created a portfolio for them.",
    image:
      "data:image/png;base64,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",
    tags: [
      "React Js",
      "PostgressSQL",
      "Node Js",
      "Express Js",
      "Redux",
      "React Flow",
    ],
    category: "web app",
    github: "",
    webapp: "https://port-jaydeep.netlify.app/",
  },
 
  {
    id: 0,
    title: "Podstream",
    date: "Apr 2023 - May 2023",
    description:
      "Developed a full-stack web application that allows users to search for, play, and pause their favorite podcasts on demand and create podcasts. Implemented user authentication using Google Auth and Jwt Auth, made responsive user interface with React JS that provides users with a seamless experience across all devices. Practiced agile methodologies to optimize team efficiency and communication.",
    image:
      "https://user-images.githubusercontent.com/64485885/234602896-a1bd8bcc-b72b-4821-83d6-8ad885bf435e.png",
    tags: ["React Js", "MongoDb", "Node Js", "Express Js", "Redux"],
    category: "web app",
    github: "",
    webapp: "",
    member: [
      {
        name: "jaydeep ",
        img: "",
        linkedin: "",
        github: "",
      },
      {
        name: "shatakshi",
        img: "",
        linkedin: "",
        github: "",
      },
    ],
  },
  {
    id: 1,
    title: "omega",
    date: "Oct 2023 - Jan 2024",
    description:
      "Designed and developed the omega project, a project management app that helps users and teams stay organized and on track. Implemented key features such as task tracking, team collaboration, and time tracking to improve productivity and project outcomes and also invite team/project members. The plan is to add a community of users where they can find developers and other team members and chat system implementation.",
    image:
      "https://user-images.githubusercontent.com/64485885/234916413-96296f13-fe4b-4cc4-b215-e72bd7c27928.png",
    tags: [
      "React Js",
      "MongoDb",
      "Node Js",
      "Express Js",
      "Redux",
      "NodeMailer",
    ],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 2,
    title: "Brain Tumor Detection",
    date: "Jan 2024- Mar 2024",
    description:
      "Preprocessed and augmented the dataset to improve model accuracy, trained the model, created API using model and Python, and used React web app for the project's front end. Achievements: Achieved an accuracy of 99.2% to accurately detect brain tumors from medical images.",
    image:
      "https://media.springernature.com/lw685/springer-static/image/art%3A10.1007%2Fs10916-019-1368-4/MediaObjects/10916_2019_1368_Fig1_HTML.jpg",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "",
    webapp: "",
    member: [
      {
        name: "jaydeep",
        img: "",
        linkedin: "",
        github: "",
      },
      {
        name: "shatakshi",
        img: "",
        linkedin: "",
        github: "",
      },
    ],
  },
 
  {
    id: 10,
    title: "Job Finding App",
    date: "Jun 2024 - Jul 2024",
    description:
      "A Job Finding App made with React Native, Axios. Users can search for any job coming from API and apply there.",
    image:
      "https://user-images.githubusercontent.com/64485885/255237090-cf798a2c-1b41-4bb7-b904-b5353a1f08e8.png",
    tags: ["React Native", "JavaScript", "Axios"],
    category: "android app",
    github: "",
    webapp: "",
  },
  {
    id: 4,
    title: "Whatsapp Clone",
    date: "Jul 2021",
    description:
      "A WhatsApp clone made with React JS, Firebase, and Material UI. It has Phone Authentication, Real-time Database. It has a chat room where users can chat with each other. It has a sidebar where users can see all the chat rooms and can create a new chat room. It has a login page where users can log in with their Google account.",
    image:
      "https://firebasestorage.googleapis.com/v0/b/whatsapp-clone-rishav.appspot.com/o/Screenshot%20(151).png?alt=media&token=48391593-1ef0-4a8c-a92a-eb82bdf38e89",
    tags: ["React Js", "Firebase", "Firestore", "Node JS"],
    category: "web app",
    github: "",
    webapp: "",
  },
  {
    id: 5,
    title: "Todo Web App",
    date: "Jun 2021",
    description:
      " A Todo Web App made with React JS, Redux, and Material UI. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the tasks and can create a new task. It has a calendar where users can see all the tasks on a particular date. It has a search bar where users can search for a particular task.",
    image:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxWLsBJzl0s-zIcj2O47QK4YI9orzZKjUVDA&s",
    tags: ["React Js", "Local Storage", "AWS Auth", "Node JS"],
    category: "web app",
    github: "",
    webapp: "",
  },
  
  {
    id: 7,
    title: "Quiz App",
    date: "Dec 2023 - Jan 2024",
    description:
      "A android quiz app made with Java and Firebase. It has a login page where users can log in with their Google account. It has a sidebar where users can see all the quiz categories and can create a new quiz. It has a leaderboard where users can see the top 10 scorers. It has a search bar where users can search for a particular quiz.",
    image:
      "https://github-production-user-asset-6210df.s3.amazonaws.com/64485885/239726262-c1b061d1-d9d0-42ef-9f1c-0412d14bc4f6.gif",
    tags: ["Java", "Android Studio", "Firebase", "Google Auth"],
    category: "android app",
    github: "",
    webapp: "",
  },
  {
    id: 8,
    title: "Face Recognition",
    date: "Jan 2024",
    description:
      "A Face recognition python app made with OpenCV. It uses face_recognition library to detect faces. It uses the webcam to detect faces. It also has a search bar to search for a particular face.",
    image:
      "data:image/jpeg;base64,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",
    tags: ["Python", "Keras", "TensorFlow", "VGG16", "Pickle", "React"],
    category: "machine learning",
    github: "",
    webapp: "",
  },
];

